import { HttpClient } from "@angular/common/http";
import { Component, Input, OnInit } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { NzModalRef } from "ng-zorro-antd/modal";

interface InputData {
  id: number;
  cover: string;
  title: string;
}

@Component({
  selector: "widget-edit-house",
  templateUrl: "./edit-house.component.html",
  styleUrls: ["./edit-house.component.scss"],
})
export class EditHouseComponent implements OnInit {
  @Input() type: "house" | "type" = "house";
  @Input() data: InputData;

  get updateApi() {
    return this.type === "house" ? "/api/house/update" : "/api/house_type/update";
  }

  form: UntypedFormGroup = this.fb.group({
    title: null,
    cover: null,
  });

  constructor(
    private fb: UntypedFormBuilder,
    private http: HttpClient,
    private modalRef: NzModalRef,
  ) {}

  ngOnInit() {
    console.log("this.data: ", this.data);

    if (this.data) {
      this.form.patchValue({
        title: this.data.title,
        cover: this.data.cover ? [{ urls: { original_url: this.data.cover } }] : null,
      });
    }
  }

  private requestUpdate(params) {
    return this.http.post(this.updateApi, params);
  }

  onCancel() {
    this.modalRef.destroy();
  }

  onSave() {
    const value = this.form.value;

    console.log("form.value: ", value, " data.cover: ", this.data.cover);

    const params = {
      title: value.title,
    };
    if (this.type === "house") {
      Object.assign(params, { house_id: this.data.id });
    } else {
      Object.assign(params, { house_type_id: this.data.id });
    }

    if (value.cover?.length === 0) {
      Object.assign(params, { cover: null })
    } else if (value.cover?.[0]?.urls?.original_url !== this.data.cover) {
      Object.assign(params, { cover: value.cover?.[0]?.urls });
    }

    this.requestUpdate(params).subscribe((rst: any) => {
      this.modalRef.destroy({ status: "ok" });
    });
  }
}
